import { ChevronsUpDown } from 'lucide-react'
import { BreadcrumbItem } from '@/components/ui/breadcrumb'
import { Skeleton } from '@/components/ui/skeleton'

export const DatabaseSwitcherFallback = () => (
  <BreadcrumbItem>
    <div className="flex items-center gap-2">
      <div className="grid flex-1 text-left text-sm leading-tight">
        <Skeleton className="h-4 w-[140px]" />
      </div>
      <ChevronsUpDown className="size-4 ml-auto opacity-25" />
    </div>
  </BreadcrumbItem>
)
